<template>
  <div class="p-d-flex justify-content-center">
    <Message
      v-for="msg of messages"
      :severity="msg.severity"
      :key="msg.content"
      >{{ msg.content }}</Message
    >

    <Panel
      v-if="temProcessos"
      header="Processos seletivos em andamento"
      class="col-12 md:col-12 justify-content-center"
      :toggleable="false"
    >
      <DataView :value="processos" layout="grid" :rows="9">
        <template #grid="slotProps">
          <div class="col-12 md:col-12">
            <div class="formgrid grid card">
              <div class="col-12 md:col-6">
                <div class="field grid">
                  <label for="nome" class="col-12 md:col-3 font-bold"
                    >Processo seletivo</label
                  >
                  <div class="col-12 md:col-9">
                    <label for="nome">{{ slotProps.data.nome }}</label>
                  </div>
                </div>

                <div class="field grid">
                  <label for="nome" class="col-12 md:col-3 font-bold"
                    >Descrição</label
                  >
                  <div class="col-12 md:col-9">
                    <label for="nome">{{ slotProps.data.descricao }}</label>
                  </div>
                </div>

                <div class="field grid">
                  <label for="tipo" class="col-12 md:col-3 font-bold"
                    >Tipo de seletivo</label
                  >
                  <div class="col-12 md:col-9">
                  <label for="tipo">{{ slotProps.data.tipoSelecao.descricao }}</label>

  					      <!-- Button  type="reset" :label="slotProps.data.tipoSelecao.descricao "  :class=" (slotProps.data.tipoSelecao.cod == '0'
                      ? 'p-button-info'
                      : 'p-button-warning') "  / -->
                  </div>
                </div>

                <div class="field grid">
                  <label for="periodo" class="col-12 md:col-3 font-bold"
                    >Período de inscrição</label
                  >
                  <div class="col-12 md:col-9">
                    <label id="periodoINICIO" class="font-bold">{{
                      formatarDataBR(
                        slotProps.data.datHoraInicioInscricao
                      ).substring(0, 10)
                    }}</label>
                    <label>{{
                      formatarDataBR(
                        slotProps.data.datHoraInicioInscricao
                      ).substring(10)
                    }}</label>
                    <span for="periodo"> Até </span>
                    <label id="periodoFIM" class="font-bold">{{
                      formatarDataBR(
                        slotProps.data.datHoraFimInscricao
                      ).substring(0, 10)
                    }}</label>
                    <label>{{
                      formatarDataBR(
                        slotProps.data.datHoraFimInscricao
                      ).substring(10)
                    }}</label>
                    <span v-if="!inscricoesEmAberto(slotProps.data)" class="p-error font-bold ml-4">
                      {{ slotProps.data.inscricaoEncerrada ? "Inscrições encerradas"
                         : (!slotProps.data.inscricaoIniciada ? "Incrições não iniciadas" : "")
                       }}
                    </span>
                  </div>
                </div>

                <!-- <div class="field grid" v-if="!slotProps.data.analiseDocumental" >
                  <label for="periodo" class="col-12 md:col-3 font-bold">Data provável da prova</label>
                  <div class="col-12 md:col-9">
                      <label id="nome">{{ $formatarData(slotProps.data.prova.dataHoraInicioProva) }}</label>
                  </div>
                </div> -->

                <div class="field grid" v-if="slotProps.data.tipoSelecao.estagio" >
                  <label for="coeficienteMinimo" class="col-12 md:col-3 font-bold">Coeficiente escolar mínimo</label>
                  <div class="col-12 md:col-9">
                    <label id="coeficienteMinimo">{{slotProps.data.coeficienteMinimo}}</label>
                  </div>
                </div>
              </div>

              <div class="col-12 md:col-6">
                <DataTable
                  :value="slotProps.data.selecaoEstagioArea"
                  class="p-datatable-sm p-datatable-gridlines p-datatable-striped"
                  dataKey="id"
                >
                  <template #header>
                    <div class="table-header">
                      Áreas e quantidade de vagas
                    </div>
                  </template>

                  <Column field="nome" header="Área">
                    <template #body="slotProps">
                      {{ slotProps.data.area.nome }}
                      <p v-if="slotProps.data.vagas === 0" class="font-bold">
                        (Cadastro de Reserva)
                      </p>
                    </template>
                  </Column>

                  <Column header="Total de vagas">
                    <template #body="slotProps">
                      {{ slotProps.data.totalVagas }}
                    </template>
                  </Column>

                  <Column field="vagas" header="Vagas ampla concorrência" />

                  <Column header="Vagas convênio">
                    <template #body="slotProps">
                      {{slotProps.data.vagasConvenio ? slotProps.data.vagasConvenio : 0}}
                    </template>
                  </Column>

                  <Column
                    field="reservadas"
                    header="Vagas estudantes com deficiência"
                  />
                </DataTable>
              </div>

              <div class="field col-12 md:col-12">
                <router-link :to="{ name: 'inscricao', params: { processo: slotProps.data } }">
                  <Button
                    label="Inscrever-se"
                    v-if="inscricoesEmAberto(slotProps.data) && !jaEstaInscrito(slotProps.data)">
                  </Button>
                </router-link>
              </div>

              <div class="field col-12 md:col-12">
                <router-link :to="{ name: 'minha.inscricao' , params: { processo: slotProps.data }}">
                  <Button
                    label="Ver minha inscrição"
                    v-if="jaEstaInscrito(slotProps.data)"
                  ></Button>
                </router-link>
              </div>
            </div>
          </div>
        </template>
      </DataView>

    </Panel>

    <Panel
      v-else
      header="Processo seletivo em andamento"
      style="width: 80%;height: 80%"
    >
      <p>No momento, não existe processo seletivo em andamento.</p>
    </Panel>
  </div>
</template>

<script>
import { tratamentoDeErros } from "@/tratamentoDeErros";
import http from "@/http";

export default {
  mixins: [tratamentoDeErros],
  data() {
    return {
      selectedArea: null,
      token: this.$store.state.token,
      habilitaInscricoes: false,
      temProcessos: false,
      messages: [],
      processo: {
        id: null,
        nome: "",
        datHoraInicioInscricao: "",
        datHoraFimInscricao: "",
        coeficienteMinimo: null,
        areas: [],
        estadoSelecao: {},
      },
      inscricoes: [],
      inscricao: {},
      perfil: "",
    };
  },

  beforeCreate() {
    http
      .get("selecao")
      .then((resposta) => {
        this.processo = { ...resposta.data[0] };
        this.processos = resposta.data;

        this.habilitaInscricoes = this.inscricoesEmAberto(
          this.processo
          //this.processo.datHoraFimInscricao,
          //this.processo.datHoraInicioInscricao
        );
        this.processo.datHoraFimInscricao = this.formatarDataBR(
          this.processo.datHoraFimInscricao
        );
        this.processo.datHoraInicioInscricao = this.formatarDataBR(
          this.processo.datHoraInicioInscricao
        );
        this.temProcessos = true;

        this.buscarIncricoesUsuario();
      })
      .catch((erro) => {
        this.messages = this.getMessagesError(erro);
      });
  },

  methods: {
    inscricoesEmAberto(processoSelecao) {
      return processoSelecao.abertoParaInscricao;
      /* 	if(this.processo && this.processo.estadoSelecao.cod===1){
					return false;
				}
				 */
      // const dataAtual = new Date();
      // var fimInscricaoDate = new Date(data_fim_inscricao);
      // var inicioInscricaoDate = new Date(inicio);
      // return (
      //   fimInscricaoDate.getTime() >= dataAtual.getTime() &&
      //   inicioInscricaoDate.getTime() <= dataAtual.getTime()
      // );
    },

    formatarDataBR(dataUS) {
      return new Date(dataUS).toLocaleString();
    },

    buscarIncricoesUsuario() {
      http
        .get(`inscricao/usuario/${this.$store.state.usuario}`)
        .then((resposta) => {
          this.inscricoes = resposta.data;
          this.temInscricoes = this.inscricoes.length > 0;
        })
        .catch((erro) => {
          this.messages = this.getMessagesError(erro);
        });
    },

    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.inscricoes.length; i++) {
        if (this.inscricoes[i].id.selecaoEstagio.id === id) {
          index = i;
          this.inscricao = this.inscricoes[i]
          break;
        }
      }
      return index;
    },

    jaEstaInscrito(processo) {
      return this.findIndexById(processo.id) > -1;
    },
  },
};
</script>
<style scoped lang="scss">
.processo-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-em-andamento {
    background: #256029;
    color: #ffffff;
  }

  &.status-finalizado {
    background: #808080;
    color: #ffffff;
  }
}
</style>
